import { render, staticRenderFns } from "./shui.vue?vue&type=template&id=638af3e6"
import script from "./shui.vue?vue&type=script&lang=js"
export * from "./shui.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports